<script lang="ts">
import { onMount } from "svelte";
import { navigate } from "svelte-navigator";
import { Button } from "sveltestrap";
import type { StartEnd } from "../Model/StartEnd";
import { startEndService } from "../services";

  let startEnd: StartEnd[];
  let startEndValue: StartEnd;
  let isExpired: boolean = true

onMount(async () => {
  const passWord = prompt('contraseña');
  
  if (passWord != 'concejal159') {
    navigate('login')
  }

  startEnd = await startEndService.find();

  startEndValue = startEnd.find(s => s.id == 'start');  

  const dateStart =  new Date(startEndValue.dateTimeStart);
  const dateEnd = new Date(startEndValue.dateTimeStop);
  const dateNow = new (Date);

  if (dateNow > dateStart && dateNow < dateEnd){
    isExpired = false;
  }

})


async function iniVot(){
  if (confirm('Va a forzar el inicio de la votación, ¿esta seguro?')) {
    await startEndService.saveStart();

    startEndValue.status = true;
  }
}

async function closeVot(){
  if (confirm('Va a forzar el cierre de la votación, ¿esta seguro?')) {
    await startEndService.saveEnd();

    startEndValue.status = false;
  }
}


</script>

<style lang="scss">

.body-html {
    height: 100%;
    display: flex;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    max-width: 360px;
    margin: auto;
  }


  .font-tittle{
    color: white;
    font-size: 30px;
  }



</style>

  <div class="body-html">
    <div class="container">
      <div class="row">
        <div class="mb-3 mt-3 col-12 text-center">
          <h1 class="font-tittle">Panel de control</h1>
        </div>
        {#if !isExpired}

          {#if startEndValue && !startEndValue.status }
            
            <div class="col-12 mt-5">
              <Button color="success" type="button" size="lg" on:click={iniVot} block>Iniciar Encuesta</Button>
            </div>

          {:else}

            <div class="col-12 mt-5">
              <Button color="warning" type="button" size="lg" on:click={closeVot} block>Finalizar Encuesta</Button>
            </div>

          {/if}
        
        {:else}

          <div class="col-12 text-center mt-5">
          <span class="second-tittle mt-3">La votación ha concluido, consulte la votación en el siguiente enlace:</span><br>
              <Button class="result-button" type="button" size="lg" on:click={() => navigate('/results')}>Resultados</Button>
          </div>

        {/if}

      </div>
    </div>
  </div>
